import { Link } from "react-router-dom";
import { useState } from "react";
import { useAuthStore } from "../../auth/hooks";
import { useSelectFormStore, useForm } from "../../hooks";
import { AuthLayout } from "../layout";
import {
  InputForm,
  SelectForm,
  LoadingData,
  ErrorMessage,
  MainButton,
} from "../ui";
import { ConfirmCodeSection } from "../sections";
import { useFormMessages } from "../hooks";

const formData = {
  document: "",
  documentTypeId: "",
  firstName: "",
  lastName: "",
  email: "",
  phoneNumber: "",
  countryPhoneId: "",
  country: "",
  department: "",
  city: "",
  address: "",
  genderId: "",
  ipsId: "",
  password: "",
  confirmPassword: "",
};

// const formData = {
//   document: "1003565694",
//   documentTypeId: "7f7d9793-8fc8-426b-a432-6b068a5c4a8f",
//   firstName: "Oscar",
//   lastName: "Hernandez",
//   email: "oscarhgsisas@gmail.com",
//   phoneNumber: "3115083209",
//   countryPhoneId: "7a9e1fbd-8f68-4c54-8c0c-63c9d340a11c",
//   country: "Colombia",
//   department: "Cundinamarca",
//   city: "Facatativá",
//   address: "Transversal 11#5-60 este",
//   genderId: "4b8c0d68-a291-48ce-a901-f7ae12e7d123",
//   ipsId: "4278a7a7-7593-42be-8b22-9cc56c538784",
//   password: "Oscar123",
//   confirmPassword: "Oscar123",
// };

const formValidations = {
  document: [
    (value) => value.length > 7,
    "El documento debe ser mayor a 7 caracteres",
  ],
  documentTypeId: [
    (value) => value.length > 0,
    "Selecciona un tipo de documento",
  ],
  firstName: [(value) => value.length > 0, "El nombre no puede ser vacio"],
  lastName: [(value) => value.length > 0, "El apellido no puede ser vacio"],
  email: [(value) => value.includes("@"), "El email debe contener una @"],
  phoneNumber: [
    (value) => value.length > 9,
    "El numero de celular debe contener más de 9 digitos",
  ],
  countryPhoneId: [
    (value) => value.length > 0,
    "Selecciona un pais del celular",
  ],
  country: [(value) => value.length > 0, "El país no puede ser vacio"],
  department: [
    (value) => value.length > 0,
    "El departamento no puede ser vacio",
  ],
  city: [(value) => value.length > 0, "La ciudad no puede ser vacia"],
  address: [(value) => value.length > 0, "La dirección no puede ser vacia"],
  genderId: [(value) => value.length > 0, "Selecciona un género"],
  ipsId: [(value) => value.length > 0, "Selecciona una ips"],
  password: [
    (value) => value.length >= 8,
    "La clave debe ser minima de 8 caracteres",
  ],
  confirmPassword: [
    (value) => value.length >= 8,
    "La clave debe ser minima de 8 caracteres",
  ],
};

export const SignupPage = () => {
  // Datos del hook ----------------------------------------//
  const {
    isLoading: isLoadingSelectForm,
    documentTypes,
    errorMessage: errorMessageSelectForm,
    countryPhones,
    genders,
    ipss,
  } = useSelectFormStore(["documentTypes", "countryPhones", "genders", "ipss"]);

  const {
    // Props
    isLoading,
    message,
    nextStep,

    // Methods
    startRegister,
  } = useAuthStore();

  // States ------------------------------------------------//
  const [validateForm, setValidateForm] = useState(false);

  // Formulario --------------------------------------------//
  const { formState, formValidation, onInputChange, isFormValid } = useForm(
    formData,
    formValidations
  );

  const { setFormSubmitted, showErrorMessage, messageText } = useFormMessages({
    message,
    setValidateForm,
  });

  // Funciones ---------------------------------------------//
  const onRegister = (event) => {
    event.preventDefault();
    setValidateForm(true);
    if (isFormValid) {
      setFormSubmitted(true);
      startRegister(formState);
    }
  };

  // Efectos -----------------------------------------------//
  if (nextStep === "confirm-code") {
    return <ConfirmCodeSection />;
  }

  return (
    <AuthLayout>
      <h4 className="text-center">Bienvenido a Go Safe, regístrate</h4>
      <form className="login-form mt-4" onSubmit={onRegister}>
        <div className="row g-3">
          {/* Formulario estatico */}
          <>
            <div className="col-md-6">
              <InputForm
                label={"Documento"}
                type={"text"}
                validation={formValidation.documentValid}
                submit={validateForm}
                name={"document"}
                value={formState.document}
                onInputChange={onInputChange}
              />
            </div>
            <div className="col-md-6">
              <SelectForm
                label={"Tipo de documento"}
                options={documentTypes}
                labelKey={"description"}
                validation={formValidation.documentTypeIdValid}
                submit={validateForm}
                name={"documentTypeId"}
                value={formState.documentTypeId}
                onInputChange={onInputChange}
              />
            </div>
            <div className="col-md-6">
              <InputForm
                label={"Nombre"}
                type={"text"}
                validation={formValidation.firstNameValid}
                submit={validateForm}
                name={"firstName"}
                value={formState.firstName}
                onInputChange={onInputChange}
              />
            </div>
            <div className="col-md-6">
              <InputForm
                label={"Apellido"}
                type={"text"}
                validation={formValidation.lastNameValid}
                submit={validateForm}
                name={"lastName"}
                value={formState.lastName}
                onInputChange={onInputChange}
              />
            </div>
            <div className="col-md-12">
              <InputForm
                label={"Correo electrónico"}
                type={"email"}
                validation={formValidation.emailValid}
                submit={validateForm}
                name={"email"}
                value={formState.email}
                onInputChange={onInputChange}
              />
            </div>
            <div className="col-md-6">
              <InputForm
                label={"Celular"}
                type={"text"}
                validation={formValidation.phoneNumberValid}
                submit={validateForm}
                name={"phoneNumber"}
                value={formState.phoneNumber}
                onInputChange={onInputChange}
              />
            </div>
            <div className="col-md-6">
              <SelectForm
                label={"País del celular"}
                options={countryPhones}
                labelKey={"name"}
                validation={formValidation.countryPhoneIdValid}
                submit={validateForm}
                name={"countryPhoneId"}
                value={formState.countryPhoneId}
                onInputChange={onInputChange}
              />
            </div>
            <div className="col-md-12">
              <h6 className="mb-0">Dirección</h6>
            </div>
            <div className="col-md-6">
              <InputForm
                label={"Pais"}
                type={"text"}
                validation={formValidation.countryValid}
                submit={validateForm}
                name={"country"}
                value={formState.country}
                onInputChange={onInputChange}
              />
            </div>
            <div className="col-md-6">
              <InputForm
                label={"Departamento"}
                type={"text"}
                validation={formValidation.departmentValid}
                submit={validateForm}
                name={"department"}
                value={formState.department}
                onInputChange={onInputChange}
              />
            </div>
            <div className="col-md-6">
              <InputForm
                label={"Ciudad"}
                type={"text"}
                validation={formValidation.cityValid}
                submit={validateForm}
                name={"city"}
                value={formState.city}
                onInputChange={onInputChange}
              />
            </div>
            <div className="col-md-6">
              <InputForm
                label={"Dirección"}
                type={"text"}
                validation={formValidation.addressValid}
                submit={validateForm}
                name={"address"}
                value={formState.address}
                onInputChange={onInputChange}
              />
            </div>
            <div className="col-md-6">
              <SelectForm
                label={"Género"}
                options={genders}
                labelKey={"name"}
                validation={formValidation.genderIdValid}
                submit={validateForm}
                name={"genderId"}
                value={formState.genderId}
                onInputChange={onInputChange}
              />
            </div>
            <div className="col-md-6">
              <SelectForm
                label={"IPS"}
                options={ipss}
                labelKey={"name"}
                validation={formValidation.ipsIdValid}
                submit={validateForm}
                name={"ipsId"}
                value={formState.ipsId}
                onInputChange={onInputChange}
              />
            </div>
            <div className="col-md-12">
              <InputForm
                label={"Contraseña"}
                sublabel={"Minimo 8 caracteres"}
                type={"password"}
                validation={formValidation.passwordValid}
                submit={validateForm}
                name={"password"}
                value={formState.password}
                onInputChange={onInputChange}
              />
            </div>
            <div className="col-md-12">
              <InputForm
                label={"Confirma la contraseña"}
                sublabel={"Minimo 8 caracteres"}
                type={"password"}
                validation={formValidation.confirmPasswordValid}
                submit={validateForm}
                name={"confirmPassword"}
                value={formState.confirmPassword}
                onInputChange={onInputChange}
              />
            </div>
          </>
          <div className="col-md-12">
            <div className="d-grid">
              <MainButton
                type="submit"
                disabled={isLoading || isLoadingSelectForm}
              >
                Registrar
              </MainButton>
            </div>
          </div>

          {/* Mensajes */}
          <>
            {isLoading && (
              <div className="col-md-12">
                <LoadingData />
              </div>
            )}
            {showErrorMessage && (
              <div className="col-md-12">
                <ErrorMessage>{messageText}</ErrorMessage>
              </div>
            )}
          </>

          <div className="col-md-12">
            <small className="text-dark me-2">¿Ya tienes cuenta?</small>{" "}
            <Link to="/auth/login" className="text-dark fw-bold">
              Ingresa
            </Link>
          </div>
        </div>
      </form>
    </AuthLayout>
  );
};
